import Notify from '@assets/js/input/notify';
import UserTokenService from '../../../../../assets/editor/js/services/UserTokenService';
import {simpleRequest, delay} from '@assets/js/input/helper';
import ReactDOM from 'react-dom';
import {showModal, appendTitle} from '@assets/js/input/modal_helper';
import FilemanagerService from '@assets/services/FilemanagerService';
import MonolitService from '@assets/services/MonolitService';
import {handleError} from '@assets/middlewares/errorHandler';
import {initFilemanager} from './index';

const notify = new Notify();
const filemanagerService = new FilemanagerService();
const monolitService = new MonolitService();
const userTokenService = new UserTokenService();

export const downloadFile = async (fileId, isSveden = false) => {
    try {
        const link = document.createElement('a');
        const token = await userTokenService.getToken();
        const filemanagerDomain = filemanagerService.getDomain();
        const href = `${filemanagerDomain}file/${fileId}?token=${token}&sveden=${Number(isSveden)}`;
        link.setAttribute('href', href);
        link.setAttribute('download', 'download');
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    } catch (e) {
        handleError(e);
    }
};

export const downloadApplicantFile = async (fileLink, isPreview) => {
    try {
        const link = document.createElement('a');
        const token = await userTokenService.getToken();
        let href = `${fileLink}?token=${token}`;
        if (isPreview) {
            link.setAttribute('target', '_blank');
            href += '&preview=1';
        }
        link.setAttribute('href', href);
        link.setAttribute('download', 'download');
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    } catch (e) {
        handleError(e);
    }
};

export const createNewVersion = () => {
    simpleRequest('/update/updateVersionJson');
};

export const downloadArchive = async (archiveName) => {
    try {
        const link = document.createElement('a');
        const token = await userTokenService.getToken();
        const filemanagerDomain = filemanagerService.getDomain();
        const href = `${filemanagerDomain}file/archive/${archiveName}?token=${token}`;
        link.setAttribute('href', href);
        link.setAttribute('download', 'download');
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    } catch (e) {
        handleError(e);
    }
};

export const downloadSavedArchive = async (name) => {
    try {
        const link = document.createElement('a');
        const token = await userTokenService.getToken();
        const filemanagerDomain = filemanagerService.getDomain();
        const href = `${filemanagerDomain}file/savedArchive/get?token=${token}&name=${name}`;
        link.setAttribute('href', href);
        link.setAttribute('download', 'download');
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    } catch (e) {
        handleError(e);
    }
};

export const downloadIntervalDateArchive = async (name) => {
    try {
        const link = document.createElement('a');
        const token = await userTokenService.getToken();
        const filemanagerDomain = filemanagerService.getDomain();
        const href = `${filemanagerDomain}file/intervalDateArchive/get?token=${token}&name=${name}`;
        link.setAttribute('href', href);
        link.setAttribute('download', 'download');
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    } catch (e) {
        handleError(e);
    }
};

export const downloadDpZajavlArchive = async (fileId) => {
    try {
        const link = document.createElement('a');
        const token = await userTokenService.getToken();
        const filemanagerDomain = filemanagerService.getDomain();
        link.setAttribute('href', `${filemanagerDomain}api/admission_committees/applicants/zajavl/archive/download/?id=${fileId}&token=${token}`);
        link.setAttribute('download', 'download');
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    } catch (e) {
        handleError(e);
    }
};

export const initToggle = () => {
    $('[data-toggle="tooltip"]').tooltip({
        container: 'body',
    });
};

export const filemanagerErrorMsg = (messages) => {
    let msg = '';
    messages.forEach((item) => {
        msg += `${item}<br>`;
    });
    return msg;
};

export const getFilesOnEditorPage = async () => {
    try {
        const tableId = $('#sprTableId').val();
        const rowId = $('#row_id').val();
        return filemanagerService.getFilesOnEditorPage(tableId, rowId);
    } catch (e) {
        handleError(e);
    }
};

export const resetFiles = (fieldName) => {
    const blocksFiles = $(`#${fieldName}`);
    blocksFiles.each((i, element) => {
        $(element).removeClass('created');
        ReactDOM.unmountComponentAtNode(element);
    });
    initFilemanager();
};

export const saveFiles = async (data) => {
    try {
        const tableId = $('#sprTableId').val();
        const rowId = $('#row_id').val();
        const dataExtended = {
            ...data,
            tableId,
            rowId,
        };
        return filemanagerService.saveFiles(dataExtended);
    } catch (e) {
        handleError(e);
    }
};

export const getHistory = async (data) => {
    try {
        const response = await monolitService.getHistory(data);
        if (response.success) {
            if (response.info !== '') {
                $('body').append(response.info).find('.dlg').removeClass('dlg').addClass('fileHistory');
                showModal('.fileHistory');
                appendTitle('.fileHistory', data.title);
            }
        } else {
            notify.showMessage('onError', response.message);
        }
    } catch (e) {
        handleError(e);
    }
};
